/**
 * Maps the backend-stamped `row.compare_sales` payload (built by
 * `backend/shared/exception_queries/compare_target.py:build_compare_sales_target`)
 * onto the `CompareSalesTarget` shape the compare dialog hook consumes.
 *
 * Eligibility is API-driven: the backend only stamps the key on rows where
 * the LS<->Xero comparison makes sense, so presence of the payload IS the
 * gate - no per-config field mapping or exclusion lists. The opener adds
 * `fpCode` (table-level prop, or `row.fp_code` on platform rows).
 */

import type { CompareSalesTarget } from '../../../hooks/useCompareSalesDialog'

export const compareTargetFromRow = (
  row: Record<string, any>,
): Omit<CompareSalesTarget, 'fpCode'> | null => {
  const t = row?.compare_sales
  if (!t?.ls_id) return null
  return {
    lsId: String(t.ls_id),
    xeroInvoiceId: t.xero_invoice_id,
    invoiceNumber: t.invoice_number ?? undefined,
    xeroReference: t.xero_reference ?? undefined,
    xeroInvoiceNumber: t.xero_invoice_number ?? undefined,
    lightspeedSaleLink: t.lightspeed_sale_link ?? undefined,
    xeroInvoiceLink: t.xero_invoice_link ?? undefined,
  }
}
